module.exports = __webpack_public_path__ + "static/img/2.e432659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/2.jpg
// module id = tMaF
// module chunks = 0